import axios from "axios";
import { checkResponse } from "src/components/js/statics1";

export async function attachment_upload(
  file,
  keikkaId,
  personId,
  asiakasId,
  tyomaaId,
  vehicleId,
  sijaintiId,
  ownerAsiakasId,
  newFileName,
  fileComment,
  entryByPersonId,
  token
) {
  const validTypes = ["image/jpeg", "image/png", "application/pdf"];
  if (!validTypes.includes(file.type)) {
    console.log("Invalid file type. Please upload a JPG, PNG, or PDF.");
    return null;
  }
  const currentYear = new Date().getFullYear();
  const fileFolder = `${ownerAsiakasId}/${currentYear}`;

  const uploadUrl = await attachment_upload_Azure(file, newFileName, fileFolder);
  if (uploadUrl) {
    // upload successful, now save to SQL
    const fileUrl = uploadUrl;
    const fileEtag = "0";
    const attachmentId = await attachment_upload_sql(
      keikkaId,
      personId,
      asiakasId,
      tyomaaId,
      vehicleId,
      sijaintiId,
      entryByPersonId,
      ownerAsiakasId,
      newFileName,
      fileUrl,
      fileFolder,
      fileComment,
      fileEtag,
      token,
      file.name,
      file.type,
      file.size
    );
    return attachmentId;
  }
  console.log("Upload failed");
  return false;
}
async function attachment_upload_Azure(file, newFileName, fileFolder) {
  if (!file) {
    console.log("No file selected.");
    return false;
  }
  // Generate the SAS token URL
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/generateSASToken";
  const response = await axios.get(fullUrl, {
    params: {
      fileFolder: fileFolder,
      fileName: newFileName,
    },
  });

  const { uploadUrl } = response.data;
  // Upload the file to Azure Blob Storage
  const config = {
    headers: { "x-ms-blob-type": "BlockBlob" },
  };
  await axios.put(uploadUrl, file, config);
  return uploadUrl;
}
async function attachment_upload_sql(
  keikkaId,
  personId,
  asiakasId,
  tyomaaId,
  vehicleId,
  sijaintiId,
  entryByPersonId,
  ownerAsiakasId,
  newFileName,
  fileUrl,
  fileFolder,
  fileComment,
  fileEtag,
  token,
  origFileName,
  fileType,
  fileSize
) {
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      keikkaId: keikkaId,
      personId: personId,
      asiakasId: asiakasId,
      tyomaaId: tyomaaId,
      vehicleId: vehicleId,
      sijaintiId: sijaintiId,
      entryByPersonId: entryByPersonId,
      ownerAsiakasId: ownerAsiakasId,
      origFileName: origFileName,
      fileName: newFileName,
      fileType: fileType,
      fileUrl: fileUrl,
      fileFolder: fileFolder,
      fileComment: fileComment,
      fileSize: fileSize,
      fileEtag: fileEtag,
    }),
  };
  try {
    const r = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/attachments/upload",
      requestOptions
    );
    const data = await r.json();
    return data?.attachmentId;
  } catch (error) {
    console.log(error);
    return false;
  }
}

export async function attachment_delete(attachmentId, token) {
  const requestOptions = {
    method: "DELETE",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/attachments/delete/" + attachmentId,
      requestOptions
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return false;
  }
}

export async function attachment_listAll(keikkaId, token) {
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": `${token}`,
    },
  };
  try {
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/attachments/listAll/" + keikkaId,
      requestOptions
    );
    const cResponse = await checkResponse(response, "attachments:listAll");
    if (!cResponse.success) {
      return false;
    }
    return cResponse.data;
  } catch (error) {
    console.log(error);
    return false;
  }
}

export async function attachment_listMissing(ownerAsiakasId, token) {
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": `${token}`,
    },
  };
  try {
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/attachments/listMissing/" + ownerAsiakasId,
      requestOptions
    );
    const cResponse = await checkResponse(response, "attachments:listMissing");
    if (!cResponse.success) {
      return false;
    }
    return cResponse.data;
  } catch (error) {
    console.log(error);
    return false;
  }
}

export async function attachment_get(attachmentId, token) {
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": `${token}`,
    },
  };
  try {
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/attachments/get/" + attachmentId,
      requestOptions
    );
    const cResponse = await checkResponse(response, "attachments:getFileUrl");
    if (!cResponse.success) {
      return false;
    }
    return cResponse.data;
  } catch (error) {
    console.log(error);
    return false;
  }
}

export async function attachment_attachToKeikka(attachmentId, keikkaId, token) {
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL +
      "/api/attachments/attachToKeikka/" +
      attachmentId +
      "/" +
      keikkaId,
      requestOptions
    );
    return response.ok;
  } catch (error) {
    console.log(error);
    return false;
  }
}

export async function attachment_updateSQL(attachment, token) {
  if (!attachment) {
    console.log("No attachment provided");
    return false;
  }
  const attachmentId = attachment.attachmentId;
  const fileComment = attachment.fileComment;
  const liitaLaskuun = attachment.liitaLaskuun;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      fileComment: fileComment,
      liitaLaskuun: liitaLaskuun,
    }),
  };
  try {
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/attachments/update/" + attachmentId,
      requestOptions
    );
    return response.ok;
  } catch (error) {
    console.log(error);
    return false;
  }
}

export async function attachment_searchSQL(ownerAsiakasId, search, token) {
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": `${token}`,
    },
  };
  try {
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/attachments/search/" + ownerAsiakasId + "/" + search,
      requestOptions
    );
    const cResponse = await checkResponse(response, "attachments:search");
    if (!cResponse.success) {
      return false;
    }
    return cResponse.data;
  } catch (error) {
    console.log(error);
    return false;
  }
}
export async function attachments_getByKeikkaIds(keikkaIds, token) {
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      keikkaIds: keikkaIds,
    }),
  };
  try {
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/attachments/getByKeikkaIds",
      requestOptions
    );
    const cResponse = await checkResponse(response, "attachments:getByKeikkaIds");
    if (!cResponse.success) {
      return false;
    }
    return cResponse.data;
  } catch (error) {
    console.log(error);
    return false;
  }
}
